module.exports = __webpack_public_path__ + "static/media/SWSCRC6-46.996db4b1.mp3";